import * as React from 'react';
import classNames from 'classnames';
import './Breadcrumb.scss';

export interface IBreadcrumbItemProps {
  className?: string;
  children?: any;
  active?: boolean;
}

const BreadcrumbItem = ({ className, active, children }: IBreadcrumbItemProps) => (
  <li 
    className={classNames(
      'breadcrumb-item', 
      active && 'is-active',
      className
    )}
  >
    {children}
  </li>
);

export default BreadcrumbItem;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/BreadcrumbItem.tsx